<template>
    <div class="report_excel">
        <div class="table-wrap">
            <div class="export-inner">
                <el-form
                    :inline="true"
                    class="leader-style-form form-table"
                    ref="addForm"
                    :model="addForm"
                    label-width="100px"
                >
                    <!-- :disabled="show_day.length" -->
                    <el-form-item
                        prop="from_date"
                        label="开始日期"
                        :rules="[
                            {
                                required: true,
                                message: '请选择开始日期',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-date-picker
                            v-model="addForm.from_date"
                            placeholder="选择开始日期"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker
                    ></el-form-item>
                    <el-form-item
                        prop="to_date"
                        label="结束日期"
                        :rules="[
                            {
                                required: true,
                                message: '请选择结束日期',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-date-picker
                            v-model="addForm.to_date"
                            placeholder="选择结束日期"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker
                    ></el-form-item>
                    <el-form-item>
                        <el-button
                            class="leader-common-button"
                            @click="eportReport"
                            >导出</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import { getReportExcel } from "@/http/api.js";
import dayjs from "dayjs";
export default {
    data() {
        return {
            addForm: {
                from_date: "",
                to_date: ""
            },

            time: "",
            nextTimeDisabled: false
            // pickerOptions: {
            //     disabledDate(time) {
            //         return time.getTime() > Date.now();
            //     }
            // }
        };
    },
    created() {
        const current_month = dayjs().format("YYYY-MM");
        this.addForm.to_date = current_month + "-23";

        this.addForm.from_date =
            dayjs(new Date(current_month))
                .subtract(1, "months")
                .format("YYYY-MM") + "-24";
    },
    methods: {
        eportReport() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    const diff = dayjs(this.addForm.to_date).diff(
                        dayjs(this.addForm.from_date),
                        "day"
                    );
                    if (diff >= 60) {
                        this.$message({
                            message: "时间查询范围不可大于60天",
                            type: "warning"
                        });
                        return;
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: "下载中",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });

                    getReportExcel({
                        from_date: this.addForm.from_date,
                        to_date: this.addForm.to_date
                    }).then(res => {
                        if (res) {
                            const content = res;
                            const blob = new Blob([content]);
                            const fileName = "报表" + ".xlsx";
                            if (window.navigator.msSaveOrOpenBlob) {
                                navigator.msSaveBlob(blob, fileName);
                            } else {
                                let link = document.createElement("a");
                                link.href = window.URL.createObjectURL(blob);
                                link.download = fileName;
                                document.body.appendChild(link);
                                let evt = document.createEvent("MouseEvents");
                                evt.initEvent("click", false, false);
                                link.dispatchEvent(evt);
                                document.body.removeChild(link);
                            }
                            this.$message({
                                message: "下载成功！",
                                type: "success"
                            });
                        }
                        loading.close();
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.report_excel {
    width: 100%;
    height: 100%;
    padding: 2rem;
    box-sizing: border-box;
    .table-wrap {
        height: 100%;
    }
    .el-range-editor .el-range-input {
        background: transparent;
        color: #fff;
    }
    .el-date-editor .el-range-separator {
        color: #fff;
    }
    .export-inner {
        width: 100%;
        height: 100%;
        // width: 50%;
        // min-width: 640px;
        // margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-form {
            margin-top: -60px;
        }
    }
}
</style>
